export function ModuleTitleER() {
  return (
    <div className="flex items-baseline gap-3">
      <h2
        className="patria-module-title text-lg sm:text-xl"
        data-testid="er-module-title"
      >
        ER CENTER
      </h2>
      <span className="text-xs uppercase tracking-widest text-charcoal-muted">
        Employee Relations Center Of Excellence
      </span>
    </div>
  );
}
